/**
 * Estonian-collated alphabetical sort. Returns a NEW array; the input is
 * left untouched. Stable on duplicates (Array.prototype.sort is stable in
 * V8/JSC since ES2019).
 *
 * `sensitivity: 'base'` so casing is ignored ("õun" sorts with "Õun"), and
 * Estonian collation orders Š/Ž/Õ/Ä/Ö/Ü as a native speaker expects rather
 * than dumping them at the end like ASCII would.
 */
export function sortByName<T extends { name: string }>(xs: readonly T[]): T[] {
  return [...xs].sort((a, b) => a.name.localeCompare(b.name, "et", { sensitivity: "base" }));
}
